import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

const productsUrl = `${apiUrl}products`;

export const productsGet = (includeInactive) => {
    const query = includeInactive ? "?includeInactive=true" : "";
    return axios.get(`${productsUrl}${query}`);
};

export const productsGetById = (id) =>
    axios.get(`${productsUrl}/${id}`);

export const productCreate = (data) =>
    axios.post(`${productsUrl}`, data);

export const productUpdate = (id, data) =>
    axios.put(`${productsUrl}/${id}`, data);

export const productDelete = (id) =>
    axios.delete(`${productsUrl}/${id}`);
